import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { setSliceRatio } from '../../../../redux/slices/FJSliceAIPhotoEditor';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJTextToImageRatio from '../../../FJTextToImage/FJTextToImageLeft/view/FJTextToImageRatio';
import { AI_PHOTO_EDITOR_MODELS } from '../../../../config/dataConfig/FJAIPhotoEditorData';
import FJConstant from '../../../../constants/FJConstant.js';

const FJAIPhotoEditorRatioContainer = memo(function FJAIPhotoEditorRatioContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const curRatio = useSelector(state => state.aiPhotoEditor.curRatio);
    const curModel = useSelector(state => state.aiPhotoEditor.curModel);

    const changeRatio = useCallback(
        ratio => {
            dispatch(setSliceRatio(ratio.name));
        },
        [dispatch],
    );

    const curModelObj = useMemo(() => {
        return AI_PHOTO_EDITOR_MODELS.find(item => item.value === curModel);
    }, [curModel]);

    return (
        <FJTextToImageRatio
            curRatio={curRatio}
            changeRatio={changeRatio}
            curModelObj={curModelObj}
            boxStyle={{ marginTop: 0 }}
            type={FJConstant.FOOTER}
            placement='topLeft'
            offsetLeft={0}
            offsetTop={-4}
        />
    );
});

export default FJAIPhotoEditorRatioContainer;
